import { render, staticRenderFns } from "./EstimateApproval2ChatModal.vue?vue&type=template&id=262b4326&scoped=true&"
import script from "./EstimateApproval2ChatModal.vue?vue&type=script&lang=js&"
export * from "./EstimateApproval2ChatModal.vue?vue&type=script&lang=js&"
import style0 from "./EstimateApproval2ChatModal.vue?vue&type=style&index=0&id=262b4326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b4326",
  null
  
)

export default component.exports